import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/Layout";
import { PlayerProvider } from "./context/PlayerContext";
import { AuthProvider } from "./context/AuthContext";

import Home from "./pages/Home";
import Category from "./pages/Category";
import TrackDetail from "./pages/TrackDetail";
import Live from "./pages/Live";
import { News, NewsDetail } from "./pages/News";
import Search from "./pages/Search";
import Downloads from "./pages/Downloads";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminStreams from "./pages/admin/AdminStreams";
import AdminContent from "./pages/admin/AdminContent";
import AdminArticles from "./pages/admin/AdminArticles";
import AdminReciters from "./pages/admin/AdminReciters";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminUsers from "./pages/admin/AdminUsers";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <div className="App">
      <PlayerProvider>
        <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/track/:id" element={<TrackDetail />} />
              <Route path="/live" element={<Live />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route path="/search" element={<Search />} />
              <Route path="/downloads" element={<Downloads />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="streams" element={<AdminStreams />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="articles" element={<AdminArticles />} />
              <Route path="reciters" element={<AdminReciters />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="users" element={<AdminUsers />} />
            </Route>
          </Routes>
        </AuthProvider>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </PlayerProvider>
    </div>
  );
}

export default App;
